import CryptoJS from 'crypto-js'

const SECRET_KEY = import.meta.env.VITE_SECURE_STORAGE_KEY || 'defaultSecureStorageKey'

if (!import.meta.env.VITE_SECURE_STORAGE_KEY) {

}

interface StoredToken {
  value: string
  expires: number
}

interface StoredOpaqueToken {
  value: string
  expires: number
}

function parseJwtExpiresAtMs(token: string): number | null {
  try {
    const parts = token.split('.')
    if (parts.length < 2) return null
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4)
    const decoded = atob(padded)
    const data = JSON.parse(decoded) as { exp?: number }
    if (!data.exp) return null
    return data.exp * 1000
  } catch {
    return null
  }
}

export const secureStorage = {
  setToken(token: string) {
    try {
      const now = new Date()
      const jwtExpiresAt = parseJwtExpiresAtMs(token)
      const item: StoredToken = {
        value: token,
        expires: jwtExpiresAt ?? (now.getTime() + (8 * 60 * 60 * 1000))
      }

      const encryptedValue = CryptoJS.AES.encrypt(
        JSON.stringify(item),
        SECRET_KEY
      ).toString()

      localStorage.setItem('secure_token', encryptedValue)
    } catch (error) {

    }
  },

  getToken(): string | null {
    try {
      const encryptedValue = localStorage.getItem('secure_token')
      if (!encryptedValue) return null

      const decrypted = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY)
      const item: StoredToken = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))

      if (new Date().getTime() > item.expires) {
        this.removeToken()
        return null
      }

      return item.value
    } catch (error) {

      return null
    }
  },

  removeToken() {
    localStorage.removeItem('secure_token')
  },

  setRefreshToken(token: string) {
    try {
      const now = new Date()
      const item: StoredOpaqueToken = {
        value: token,
        expires: now.getTime() + (30 * 24 * 60 * 60 * 1000)
      }
      const encryptedValue = CryptoJS.AES.encrypt(
        JSON.stringify(item),
        SECRET_KEY
      ).toString()
      localStorage.setItem('secure_refresh_token', encryptedValue)
    } catch {
    }
  },

  getRefreshToken(): string | null {
    try {
      const encryptedValue = localStorage.getItem('secure_refresh_token')
      if (!encryptedValue) return null
      const decrypted = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY)
      const item: StoredOpaqueToken = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
      if (new Date().getTime() > item.expires) {
        this.removeRefreshToken()
        return null
      }
      return item.value
    } catch {
      return null
    }
  },

  removeRefreshToken() {
    localStorage.removeItem('secure_refresh_token')
  },

  isTokenExpired(): boolean {
    try {
      const encryptedValue = localStorage.getItem('secure_token')
      if (!encryptedValue) return true

      const decrypted = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY)
      const item: StoredToken = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))

      return new Date().getTime() > item.expires
    } catch {
      return true
    }
  },

  setIsAdmin(isAdmin: boolean) {
    try {
      const encryptedValue = CryptoJS.AES.encrypt(
        JSON.stringify(isAdmin),
        SECRET_KEY
      ).toString()

      localStorage.setItem('is_admin', encryptedValue)
    } catch (error) {

    }
  },

  getIsAdmin(): boolean {
    try {
      const encryptedValue = localStorage.getItem('is_admin')
      if (!encryptedValue) return false

      const decrypted = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY)
      return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
    } catch (error) {

      return false
    }
  },

  removeIsAdmin() {
    localStorage.removeItem('is_admin')
  },

  setActiveProjectId(projectId: string) {
    localStorage.setItem('active_project_id', projectId)
  },

  getActiveProjectId(): string | null {
    return localStorage.getItem('active_project_id')
  },

  removeActiveProjectId() {
    localStorage.removeItem('active_project_id')
  }
}